/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dailog_Open_Confirmation_TitleInputs */

const en_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open a Cake Box?`)
};

const ar_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح صندوق كعك؟`)
};

const de_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Kuchenbox öffnen?`)
};

const es_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Abrir una caja de pasteles?`)
};

const fr_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir une boîte à gâteaux ?`)
};

const it_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprire una scatola di torte?`)
};

const ja_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケーキボックスを開けますか？`)
};

const ko_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`케이크 상자를 개봉하시겠습니까?`)
};

const pt_br_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir uma caixa de bolo?`)
};

const ru_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть коробку с тортом?`)
};

const th_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดกล่องเค้ก?`)
};

const tr_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta kutusu açılsın mı?`)
};

const zh_cn_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开蛋糕礼盒？`)
};

const zh_tw_dailog_open_confirmation_title = /** @type {(inputs: Dailog_Open_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打開蛋糕禮盒？`)
};

/**
* | output |
* | --- |
* | "Open a Cake Box?" |
*
* @param {Dailog_Open_Confirmation_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dailog_open_confirmation_title = /** @type {((inputs?: Dailog_Open_Confirmation_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dailog_Open_Confirmation_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dailog_open_confirmation_title(inputs)
	if (locale === "ar") return ar_dailog_open_confirmation_title(inputs)
	if (locale === "de") return de_dailog_open_confirmation_title(inputs)
	if (locale === "es") return es_dailog_open_confirmation_title(inputs)
	if (locale === "fr") return fr_dailog_open_confirmation_title(inputs)
	if (locale === "it") return it_dailog_open_confirmation_title(inputs)
	if (locale === "ja") return ja_dailog_open_confirmation_title(inputs)
	if (locale === "ko") return ko_dailog_open_confirmation_title(inputs)
	if (locale === "pt_br") return pt_br_dailog_open_confirmation_title(inputs)
	if (locale === "ru") return ru_dailog_open_confirmation_title(inputs)
	if (locale === "th") return th_dailog_open_confirmation_title(inputs)
	if (locale === "tr") return tr_dailog_open_confirmation_title(inputs)
	if (locale === "zh_cn") return zh_cn_dailog_open_confirmation_title(inputs)
	return zh_tw_dailog_open_confirmation_title(inputs)
});